module.exports = __webpack_public_path__ + "static/img/banner_invite.6804796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_invite.png
// module id = 9goU
// module chunks = 1